import { render, staticRenderFns } from "./DeviceStatusForChartLegende.vue?vue&type=template&id=2f0de515"
import script from "./DeviceStatusForChartLegende.vue?vue&type=script&lang=js"
export * from "./DeviceStatusForChartLegende.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports